import request from 'src/network';
import { DocumentOrImageV2, DocumentV2Data, DocumentWithoutMetadata, ImageV2Data } from 'src/types/DocumentOrImageV2';

const apiPath = '/api/job/search';
const apiPath2 = '/api/job/chat';

export async function getAllJobsService(settings: { user: string | number, key_filter: string, job_type: string }) {
    const response = await request.POST<DocumentOrImageV2>(`${apiPath}`, settings);
    response.items = response.items.map(item => new DocumentOrImageV2(item))
    return response;
}
export async function analyzeDocumentOrImageService(document: DocumentV2Data | ImageV2Data | DocumentWithoutMetadata) {
    const response = await request.POST<{ job_id: number }>(`${apiPath2}/es`, document);
    return response;
}